import { toast } from "@/common/view/Toast";
import { useAuth } from "./AuthContext";
import refresh from "../agent/RefreshTokenApiAgent";

export const useRenewAccessToken = () => {
    const { handleAccessToken, logout } = useAuth();

    const renewAccessToken = async () => {
        try {
            const { data } = await refresh();
            handleAccessToken({
                token: data.access_token,
                expiresAt: data.access_token_expires_at,
            })
        }catch(error) {
            toast.error("토큰 갱신에 실패했습니다. 로그인 후 다시 시도해주세요.");
            await logout();
        }
    }

    return { renewAccessToken };
}